import { ApolloError, useQuery } from '@apollo/client';

import {
  GET_COMPANY_QUESTIONS,
  GetCompanyQuestionsQuery,
  GetCompanyQuestionsQueryVariables,
  QuestionCode,
  QuestionSectionCode,
} from '../graphql';
import { useCurrentCompanyId } from './useCurrentCompanyId';

export const useCompanyInformation = (): {
  companyInformation: {
    elevatorPitch: string | null;
    elevatorPitchId: string | null;
    elevatorPitchQuestionId: string | null;
    fiscalYearEndMonth: number | null;
    companyUrl: string | null;
    companyUrlId: string | null;
    companyUrlQuestionId: string | null;
  };
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const companyId = useCurrentCompanyId();

  const {
    data: companyData,
    error: companyError,
    loading: companyLoading,
  } = useQuery<GetCompanyQuestionsQuery, GetCompanyQuestionsQueryVariables>(GET_COMPANY_QUESTIONS, {
    variables: {
      companyId,
    },
  });

  const company = companyData?.getCompany;
  const questionSections = company?.questionSections ?? [];
  const elevatorPitchQuestion = questionSections
    .find((section) => section.sectionCode === QuestionSectionCode.CompanyDetails)
    ?.questions.find((question) => question.questionCode === QuestionCode.CompanyElevatorPitch);

  const companyUrlQuestion = questionSections
    .find((section) => section.sectionCode === QuestionSectionCode.CompanyDetails)
    ?.questions.find((question) => question.questionCode === QuestionCode.CompanyUrl);

  return {
    companyInformation: {
      elevatorPitch: elevatorPitchQuestion?.answerValue || null,
      elevatorPitchId: elevatorPitchQuestion?.id || null,
      elevatorPitchQuestionId: elevatorPitchQuestion?.questionId || null,
      fiscalYearEndMonth: company?.businessQuestions.fiscalYearEndMonth ?? null,
      companyUrl: companyUrlQuestion?.answerValue || null,
      companyUrlId: companyUrlQuestion?.id || null,
      companyUrlQuestionId: companyUrlQuestion?.questionId || null,
    },
    loading: companyLoading,
    error: companyError,
  };
};
